export default __webpack_public_path__ + "static/media/3.9cf01b63.jpg";